"use client";

import { createContext, useContext, useState } from "react";

interface ContextProps {
  sidebarState: boolean;
  toggleSidebar: () => void;
  darkMode: boolean;
  toggleDarkMode: () => void;
}

var windowSizeBig: boolean = true;

if (typeof window !== "undefined") {
  windowSizeBig = window.screen.width > 768;
}

const GlobalContext = createContext<ContextProps>({
  sidebarState: windowSizeBig,
  toggleSidebar: () => {},
  darkMode: false,
  toggleDarkMode: () => {},
});

export const GlobalContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [sidebarState, setSidebarState] = useState(windowSizeBig);

  const [darkMode, setDarkMode] = useState(false);

  const toggleSidebar = () => {
    setSidebarState(() => !sidebarState);
  };

  const toggleDarkMode = () => {
    setDarkMode(() => !darkMode);
  };

  return (
    <GlobalContext.Provider
      value={{
        sidebarState,
        toggleSidebar,
        darkMode,
        toggleDarkMode,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
